export const SLICED_DESCRIPTION_HEIGHT = 130;
